export enum AssetAttributionModalMode {
  VIEW = "view",
  EDIT = "edit",
}
